import React from 'react';

const LogoSvg = ({ color = "#FFF", scale = 1, ...props }) => (
  <svg width={`${141 * scale}px`} height={`${122.01 * scale}px`}
    viewBox="0 0 141 122.01"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <title>Afromix Logo</title>
    <desc>Created with Sketch.</desc>
    <desc>Created by @chrishoval</desc>
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd" scale={scale}>
      <path id="logo"
        d="M110.39,120.74C128.59,108.82,140.5,89,140.5,66.5c0-36.45-31.34-66-70-66S.5,30,.5,66.5c0,22.53,12,42.42,30.24,54.33h0a73.11,73.11,0,0,1-2.45-10.59c-3-1-5.3-4.55-5.3-8.76,0-3.87,1.9-7.17,4.57-8.46A72.52,72.52,0,0,1,33.43,68.5c9,5.37,22.15,8.76,36.87,8.76,14.93,0,28.3-3.49,37.25-9a72.51,72.51,0,0,1,6,25c2.4,1.45,4.06,4.57,4.06,8.19,0,4-2,7.34-4.78,8.56a73.17,73.17,0,0,1-2.46,10.72Z" />
    </g>
  </svg>
);

export { LogoSvg };


// WEBPACK FOOTER //
// ./src/svgs/LogoSvg.js